"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var react_redux_1 = require("react-redux");
var validateForm_1 = require("../../../../../../../helpers/validateForm/validateForm");
var get_product_attribute_families_thunk_1 = require("../../../../../../../reducers/slices/products/product_attribute_family/thunks/get_product_attribute_families_thunk");
var product_attribute_familes_input_1 = __importDefault(require("./components/product_attribute_familes_input"));
var product_attributes_input_1 = __importDefault(require("./components/product_attributes_input"));
var get_product_attributes_thunk_1 = require("../../../../../../../reducers/slices/products/product_attribute/thunks/get_product_attributes_thunk");
var PimAttributeComponent = function (props) {
    var _a;
    var values = props.values, setValues = props.setValues, saveButton = props.saveButton;
    var _b = (0, validateForm_1.validateForm)(values === null || values === void 0 ? void 0 : values.product_attribute_family), errors = _b.errors, isValid = _b.isValid;
    var dispatch = (0, react_redux_1.useDispatch)();
    var productAttributeFamilies = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeFamilyState; }).productAttributeFamilies;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.productAttributeState; }), productAttributes = _c.productAttributes, pagination = _c.pagination;
    var client_token = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).client_token;
    var getProductAttributeFamily = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_product_attribute_families_thunk_1.get_product_attribute_families_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var getProductAttributes = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var sort_by = _a.sort_by, order_by = _a.order_by, query = __rest(_a, ["sort_by", "order_by"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_product_attributes_thunk_1.get_product_attributes_thunk)(query))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (client_token) {
            getProductAttributeFamily({});
            getProductAttributes(__assign({}, pagination));
        }
    }, [client_token]);
    return ((0, jsx_runtime_1.jsxs)(react_2.Card, __assign({ className: "w-full" }, { children: [(0, jsx_runtime_1.jsxs)(react_2.CardHeader, __assign({ className: "flex justify-between items-center px-6 py-4" }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold" }, { children: "Product Attributes" })), saveButton] })), (0, jsx_runtime_1.jsx)(react_2.Divider, {}), (0, jsx_runtime_1.jsx)(react_2.CardBody, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 gap-4 overflow-hidden" }, { children: [(0, jsx_runtime_1.jsx)(product_attributes_input_1.default, { initialAttributes: values === null || values === void 0 ? void 0 : values.attributes, attributeList: productAttributes, onChange: function (value) {
                                setValues(__assign(__assign({}, values), { attributes: value }));
                            } }), (0, jsx_runtime_1.jsx)(product_attribute_familes_input_1.default, { initialProductFamily: values === null || values === void 0 ? void 0 : values.product_attribute_family, attributeFamilyList: productAttributeFamilies, onChange: function (value) {
                                setValues(__assign(__assign({}, values), { product_attribute_family: value, attributes: value.attributes }));
                            } }, (_a = values === null || values === void 0 ? void 0 : values.product_attribute_family) === null || _a === void 0 ? void 0 : _a._id)] })) })] })));
};
exports.default = PimAttributeComponent;
